<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Gw9Yg0/tc-custom/9781526776143.jpg?1729082652321" alt="This image is the cover for the book Mail by Rail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mail by Rail
      </h1>
      <p class="bookDescription body article font2">
        <p>Railways have been used for the carriage of mail since soon after the Liverpool &amp; Manchester Railway opened in 1830, the development of the first travelling post offices following, enabling the Post Office to achieve maximum efficiencies in mail transportation. As the rail network grew the mail network grew with it, reaching a peak with the dedicated mail trains that ran between London and Aberdeen.  The Post Office also turned to railways when it sought a solution to the London traffic that hindered its operations in the Capital, obtaining powers to build its own narrow gauge, automatic underground railway under the streets to connect railway stations and sorting offices. Although construction and completion were delayed by the First World War, the Post Office (London) Railway was eventually brought into use and was an essential part of Post Office operations for many years.  Changing circumstances brought an end to both the travelling post offices and the underground railway but mail is still carried, in bulk, by train and a part of the railway has found a new life as the Mail Rail tourist attraction.  Author Peter Johnson has delved into the archives and old newspapers to uncover the inside story of the Post Office and its use of railways to carry the mail for nearly 200 years.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Johnson
      </h2>
      
      <p class="authorDescription body article">PETER JOHNSON is the author of more than 30 books, mainly about Welsh and narrow-gauge railways.  His association with the Ffestiniog Railway, as editor of the Ffestiniog Railway Society’s quarterly magazine (1974-2003), as a director of the Ffestiniog Railway Society (1992-2003) and in drafting the company’s Welsh Highland Railway Transport & Works Order, and as the compiler of a narrow-gauge railway news column for one of the mainstream British railway magazines since 1995, has put him in a good position to compile this story of the Welsh Highland Railway’s history and its revival, his third title for Pen & Sword Transport.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Copyright © Peter Johnson, 2022
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e827e552